import { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { AddproductComponent } from './addproduct/addproduct.component';
import { ImportproductComponent } from './importproduct/importproduct.component';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy {


  productColl: any = [];
  producttypeColl: any = [];
  groupColl: any = [];
  pricetypeColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Product";

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Item Code', field: 'productcode' },
    { headerName: 'Item', field: 'productname', type: 'variation' },
    { headerName: 'Group', field: 'groupname' },
    { headerName: 'Order No', field: 'productsectionorderno' },
    { headerName: 'Tax', field: 'taxname' },    
    { headerName: 'Price', field: 'price1',type:'decimal' },
    { headerName: 'Status', field: 'activestatus' ,type:'activestatus'},
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  producttype: String = "";
  groupid: number = null;
  isaddpricetype: boolean = false;

  constructor(private appService: DhukanDataService, public router: Router,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private productFindService: NgbModal, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }


  ngOnInit() {
    try {



      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetPricetype()
    this.fngetProduct();
    this.fngetProducttype();
    this.fngetGroup();

  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }
  // fngetPricetype() {
  //   var data = {
  //     'pricetypeid': 0,
  //     'companyid': this.loginService.fnGetCompanyId(),
  //   }
  //   this.appService.getPricetype(data)
  //     .subscribe(
  //       (res) => {
  //         if (res.json().status === 200) {
  //           this.pricetypeColl = res.json().result;
  //         }
  //       },
  //       (err) => {
  //         this.toastr.error('Error', err);
  //       })


  // }
  fngetProducttype() {
    this.producttypeColl = [];
    this.producttypeColl.push({ value: 'DINEIN', displayname: 'Dine In' });
    this.producttypeColl.push({ value: 'TAKEAWAY', displayname: 'Take Away' })
    this.producttypeColl.push({ value: 'DELIVERY', displayname: 'Delivery' })
    this.producttypeColl.push({ value: 'ONLINE', displayname: 'Online' })
    this.producttypeColl.push({ value: 'INACTIVE', displayname: 'Inactive' })
  }

  fngetGroup() {


    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {


          if (res.json().status == 200) {
            this.groupColl = res.json().result;



          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }
  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;
            this.fnSetTable();
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSetTable() {
    if (this.isaddpricetype) {
      return
    }
    for (let row of this.pricetypeColl) {

      if (row.pricetag === "SP1") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp1' })
      }
      else if (row.pricetag === "SP2") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp2' })
      }
      else if (row.pricetag === "SP3") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp3' })
      }
      else if (row.pricetag === "SP4") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp4' })
      }
      else if (row.pricetag === "SP5") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp5' })
      }
      else if (row.pricetag === "SP6") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp6' })
      }
      else if (row.pricetag === "SP7") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp7' })
      }
      else if (row.pricetag === "SP8") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp8' })
      }
      else if (row.pricetag === "SP9") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp9' })
      }
      else if (row.pricetag === "SP10") {
        this.columnDefs.push({ headerName: row.pricetypename, field: 'sp10' })
      }
      this.isaddpricetype = true
    }
  }
  fngetProduct() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'productid': 0,
      'groupid': this.groupid,
      'producttype': this.producttype,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getProductListview(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.productColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddProduct() {
    try {
      const modalRef = this.productFindService.open(AddproductComponent, { size: <any>'xxl', backdrop: 'static', keyboard: false });


      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetProduct();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditProduct(pBO) {

    try {
      var deptid = pBO.productid
      const modalRef = this.productFindService.open(AddproductComponent, { size: <any>'xxl', backdrop: 'static' });
      modalRef.componentInstance.productid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetProduct();
      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnViewProduct(pBO) {

    try {
      var deptid = pBO.productid
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
        }
      }

      this.router.navigate(['/AddProduct'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.productid
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Product?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteProduct(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteProduct(deptid) {

    var data = {
      'productid': deptid,
    }
    this.appService.fnDeleteProduct(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Product has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetProduct();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Grid



  fnActionEditClick(data) {

    if (!this.isedit) {
      return;
    }

    this.fnEditProduct(data.productid);

  }


  fnActionDeleteClick(data) {
    if (!this.isdelete) {
      return;
    }

    this.fnDeleteConfirm(data.productid);


  }



  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnActionExportClick() {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.productColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });
  }


  fnGetDescription(id) {
    const index = this.productColl.findIndex(sku => sku.productid === id);

    if (index) {
      return this.productColl[index].productname;
    }
    else {
      return "";
    }

  }
  fnImportBtn() {

    const modalRef = this.productFindService.open(ImportproductComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetGroup();
        this.fngetProduct();
      }

    });

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
